@let controls = formGroup.controls;
<ng-container [formGroup]="formGroup">
  @if (!disableDisplayChangePeriodValue) {
    <div class="select-period">
      @for (period of availablePeriods; track period) {
        <label tuiBlock="s" appearance="">
          <input
            type="radio"
            tuiBlock
            class="select-period"
            formControlName="periodValue"
            [value]="period.value"
          />
          {{ period.title | translate }}
        </label>
      }
    </div>
  }
  @if (controls.periodValue.value !== AvailableDateTimePeriod.Today) {
    <div class="hidden" appHeightCollapse [appHeightCollapseDuration]="500">
      @if (controls.periodValue.value === AvailableDateTimePeriod.Recently) {
        <div
          class="select-period__recently hidden"
          [class.mt-16]="!disableDisplayChangePeriodValue"
        >
          <div class="select-period__recently-input-value">
            <button
              tuiIconButton
              appearance="transparent"
              iconStart="common/assets/icons/minus.svg"
              (click)="recentlyPeriodDecrement()"
              [disabled]="formGroup.disabled"
            ></button>
            <tui-textfield [tuiTextfieldCleaner]="false">
              <input tuiInputNumber formControlName="recentlyPeriod" [min]="1" />
            </tui-textfield>
            <button
              tuiIconButton
              appearance="transparent"
              iconStart="common/assets/icons/plus.svg"
              (click)="recentlyPeriodIncrement()"
              [disabled]="formGroup.disabled"
            ></button>
          </div>
          <tui-textfield
            tuiChevron
            class="b-form recentlyPeriodType"
            [stringify]="stringifyValue(availableRecentlyPeriodTypes)"
            [tuiTextfieldCleaner]="false"
          >
            <input tuiSelect formControlName="recentlyPeriodType" />
            <tui-data-list *tuiTextfieldDropdown>
              @for (item of availableRecentlyPeriodTypes; track item) {
                <button new tuiOption type="button" [value]="item.value">
                  {{ item.title | translate }}
                </button>
              }
            </tui-data-list>
          </tui-textfield>
          <label tuiLabel>
            <input
              tuiCheckbox
              type="checkbox"
              class="currentPeriod"
              formControlName="currentPeriod"
            />
            {{ 'Current period' | translate }}
          </label>
        </div>
      }
      @if (controls.periodValue.value === AvailableDateTimePeriod.Exact) {
        <div class="select-period__exact hidden" [class.mt-16]="!disableDisplayChangePeriodValue">
          <tui-textfield [tuiTextfieldCleaner]="false">
            <input
              tuiInputDateTime
              formControlName="periodDateStart"
              [invalid]="controls.periodDateStart.invalid && controls.periodDateStart.touched"
              [max]="currentDatetime"
              (focusout)="onFocusedChangePeriodDateStart($event)"
            />
            <tui-calendar *tuiTextfieldDropdown />
          </tui-textfield>
          <div class="separator">—</div>
          <tui-textfield [tuiTextfieldCleaner]="false">
            <input
              tuiInputDateTime
              formControlName="periodDateEnd"
              [invalid]="controls.periodDateEnd.invalid && controls.periodDateEnd.touched"
              [min]="controls.periodDateStart.value"
              [max]="currentDatetime"
              (focusout)="onFocusedChangePeriodDateEnd($event)"
            />
            <tui-calendar *tuiTextfieldDropdown />
          </tui-textfield>
        </div>
      }
    </div>
  }
</ng-container>
